import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ClaimSuccessIcon from "../../../components/icons/ClaimSuccessIcon";

interface Props {
  show: boolean;
  onHide: () => void;
}

export default function ClaimSuccessModal({ show, onHide }: Props) {
  const navigate = useNavigate();
  const { t } = useTranslation(["raiseNewClaim"]);
  const hideFunction = () => {
    onHide();
    navigate("/my-claims");
  };
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body className="px-md-4 py-md-5">
        <div className="d-flex flex-column align-items-center text-center">
          <h2 className="primary-modal-title modal-success-title mb-2 mb-md-4">
            {t("modal.heading", { ns: "raiseNewClaim" })}
          </h2>
          <div className="claim-sucess-icon-cont p-md-2 rounded-circle mb-3 mb-md-4">
            <ClaimSuccessIcon />
          </div>
          <p className="mb-3 mb-md-4">
            {t("modal.message", { ns: "raiseNewClaim" })}
          </p>
          <button
            className="primary-button px-md-5 py-md-2"
            onClick={hideFunction}
          >
            Okay
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
